import { render, staticRenderFns } from "./invTransfer.vue?vue&type=template&id=444a3c08&"
import script from "./invTransfer.vue?vue&type=script&lang=js&"
export * from "./invTransfer.vue?vue&type=script&lang=js&"
import style0 from "./invTransfer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports